import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { BaseModel } from "../Generics/BaseModel"

export class CategoryEntity extends BaseModel {
  id: number

  name: string

  description: string

  isDefault: boolean

  displayOrder: number | null

  status: EEnableStatusType

  icon: string = "🍔"

  constructor(data: Partial<CategoryEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.name = data.name ?? ""

    this.description = data.description ?? ""

    this.icon = data.icon ?? "🍔"

    this.isDefault = data.isDefault ?? false

    this.displayOrder = data.displayOrder ?? null

    this.status = data.status ?? EEnableStatusType.Active
  }
}
